@use "@fukuri-admins/ui/layout" as *;

.headRow {
  white-space: nowrap;
}

.clientNameCol {
  min-width: 120px;
}

.nameCol {
  min-width: 100px;
}

.loginCol {
  min-width: 80px;
}

.activationCodeCol {
  min-width: 160px;
}

.emailCol {
  min-width: 160px;
}

.phoneNumberCol {
  min-width: 120px;
}

.createdAtCol {
  min-width: 120px;
}

.billableFromCol {
  min-width: 144px;
}

.updatedAtCol {
  min-width: 144px;
}

.actionCol {
  width: 60px;
  text-align: center;
}

.activationCode {
  display: flex;
  align-items: center;
  gap: spacing('4');
}

.deleteItem {
  color: text('Red');
}
